<div *ngIf="vehicleConfigService.configuration.panel.showIconsTransmision">
  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[1].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[1].transmissionStatusId
    "
    [isActive]="isActive[1]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[2].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[2].transmissionStatusId
    "
    [isActive]="isActive[2]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[3].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[3].transmissionStatusId
    "
    [isActive]="isActive[3]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[4].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[4].transmissionStatusId
    "
    [isActive]="isActive[4]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[5].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[5].transmissionStatusId
    "
    [isActive]="isActive[5]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[6].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[6].transmissionStatusId
    "
    [isActive]="isActive[6]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>

  <app-button-toggle-vehicle
    [quantityVehicle]="transmissionStatusInformation[0].quantityVehicle"
    [transmissionStatusId]="
      transmissionStatusInformation[0].transmissionStatusId
    "
    [isActive]="isActive[0]"
    (onClick)="onSelectButton($event)"
  ></app-button-toggle-vehicle>
</div>
